module.exports = __webpack_public_path__ + "static/media/people-grey.7062b188.svg";